export * from './GenericProperties';
